function LandingArrow() {
    return (
        <span aria-hidden="true">
            <span className="desktop-arrow" aria-hidden="true">↗</span>
            <svg className="arrow-icon" viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false">
                <path d="M5 19 19 5M5 5h14v14" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
        </span>
    );
}

export default LandingArrow;
